import { AdminLandingPageLink } from '@storefronts/common-types'

/** Moves the matching link to index 0 so it becomes the featured product. */
export function moveLandingPageLinkToFront(
    links: AdminLandingPageLink[],
    linkHash: string,
): AdminLandingPageLink[] {
    const index = links.findIndex((link) => link.linkHash === linkHash)
    if (index <= 0) return links

    const target = links[index]
    return [target, ...links.filter((link) => link.linkHash !== linkHash)]
}

/** Appends links to the storefront product list, deduping by linkHash. */
export function mergeUnattachedProductLinks(
    existingLinks: AdminLandingPageLink[],
    unattachedLinks: AdminLandingPageLink[],
): AdminLandingPageLink[] {
    const merged = [...existingLinks, ...unattachedLinks]
    return Array.from(
        new Map(merged.map((link) => [link.linkHash, link])).values(),
    )
}
